var SalesReportingPresenter = /** @class */ (function () {
    function SalesReportingPresenter(useCases) {
        this.useCases = useCases;
    }
    SalesReportingPresenter.prototype.getReportData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.reportData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getPaginatedListParamsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.salesPaginatedUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getReportParamsData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.reportParams.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getAllReport = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.allReports.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    SalesReportingPresenter.prototype.getHolidayList = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.salesReportingHolidayList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    SalesReportingPresenter.prototype.getMTFReportingDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.salesMTFReporting.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getMTFReportingDownloadData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.salesMTFReportDownload.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getRmPartnerReportDropdownList = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getRmPartnerReportDropdownList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getSearchedClientJWTToken = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getSalesClientReportJWT.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getZeroisingLabel = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getZeroisingLabel.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getZeroisingReportIbeats = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getZeroisingReportIbeats.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getZeroisingPopUpPublish = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getZeroisingPopUpPublish.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getZeroisingPopUpView = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getZeroisingPopUpView.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getRmPartnerReportTableColumnHeader = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getRmPartnerReportTableColumnHeader.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getRmPartnerReportTableClickEvent = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getRmPartnerReportTableClickEvent.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    SalesReportingPresenter.prototype.getGuestTokenAndEmbed = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.getGuestTokenAndEmbed.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    return SalesReportingPresenter;
}());
export default SalesReportingPresenter;
